import { NgModule } from '@angular/core';

import { CheckoutPaymentTypeService } from '@spartacus/checkout/b2b/core';
import { CheckoutPageMetaResolver } from '@spartacus/checkout/base/core';
import { CmsConfig, provideConfig } from '@spartacus/core';

import { DpPaymentTypeModule } from './modules/payment-type';
import { DpPurchaseOrderNumberModule } from './modules/purchase-order-number/purchase-order-number.module';
import { DpCheckoutPageMetaResolver } from './resolvers/checkout-page-meta.resolver';
import { DpCheckoutPaymentTypeService } from './services/checkout-payment-type.service';

@NgModule({
  imports: [DpPaymentTypeModule, DpPurchaseOrderNumberModule],
  providers: [
    { provide: CheckoutPageMetaResolver, useClass: DpCheckoutPageMetaResolver },
    { provide: CheckoutPaymentTypeService, useClass: DpCheckoutPaymentTypeService },
    provideConfig(<CmsConfig>{
      featureModules: {
        checkoutFeature: {
          cmsComponents: [
            'CheckoutReviewOrder',
            'CheckoutProgress',
            'CheckoutDeliveryAddress',
            'CheckoutPlaceOrder',
            'CheckoutDeliveryMode',
            'CheckoutPaymentType',
            'CheckoutProceedToNextStep',
            'CheckoutTitleComponent'
          ],
          module: () =>
            import('./checkout-components.module').then(({ DpCheckoutComponentsModule }) => DpCheckoutComponentsModule)
        },
        checkoutOrderSummaryFeature: {
          cmsComponents: ['CheckoutOrderSummary'],
          module: () => import('./modules/checkout-order-summary').then((m) => m.DpCheckoutOrderSummaryModule)
        }
      }
    })
  ]
})
export class DpCheckoutFeatureModule {}
